module.exports = __webpack_public_path__ + "img/publiicar.c3d9ceba.png";